import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/views/login/Login.vue'
import Home from '@/views/Home.vue'   // 新增营销首页组件

Vue.use(VueRouter)

// 基础路由（静态路由，不依赖权限）
const originalRoutes = [
  { path: '/', component: Home },        // 根路径展示营销首页
  { path: '/login', component: Login },
  ]

// 创建 router 实例的函数
const createRouter = () => new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: originalRoutes
})

let router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

export function addDynamicRoutes(menuTree) {
  resetRouter()  // 清空动态路由，保留基础路由
  const newRoutes = generateRoutes(menuTree)
  router.addRoutes(newRoutes)
}

function generateRoutes(menuTree) {
  const routes = []
  menuTree.forEach(menu => {
    if (menu.component) {
      routes.push({
        path: menu.path,
        name: menu.name,
        component: () => import(`@/${menu.component}`),
        meta: { requiresAuth: true, title: menu.name }
      })
    }
    if (menu.children && menu.children.length) {
      routes.push(...generateRoutes(menu.children))
    }
  })
  return routes
}

export default router


// 全局前置守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  // 公开页面：登录页和首页
  const publicPages = ['/', '/login']
  if (!publicPages.includes(to.path) && !token) {
    // 未登录且访问非公开页面，重定向到登录页
    next('/login')
  } else {
    next()
  }
})